import { render } from "./LocalAdventureMenu.vue?vue&type=template&id=722d110c&scoped=true"
import script from "./LocalAdventureMenu.vue?vue&type=script&lang=js"
export * from "./LocalAdventureMenu.vue?vue&type=script&lang=js"

import "./LocalAdventureMenu.vue?vue&type=style&index=0&id=722d110c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722d110c"]])

export default __exports__